import { Row, Col, Button, Spinner } from 'react-bootstrap'
import { Formik, Field, Form } from 'formik'
import * as Yup from 'yup'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import dayjs from 'dayjs'
import axios from 'axios'
import { AuthContext } from '../AuthContext'
import { useEffect, useState } from 'react'

const MetabolicPlanFormConfirm = ({
  warning,
  setWarning,
  setQrcode,
  setCaseModalShow,
  currentPatient,
  formData,
  setFormConfirmShow,
  trackFormData,
  currentTrackIndex,
}) => {
  const initialValues = {
    project_id: 'P0001',
    clinic_id: '',
    record_time: dayjs().format('YYYY-MM-DD'),
    next_appointment_time: '',
    track_type: '',
    id_number: '',
    phone: '',
    family_name: '', // 這個留空
  }
  console.log('trackFormData', trackFormData)

  const { name, gender, birthday, id_number, data, next_appointment_time } =
    trackFormData

  //   const { index_type, record_time, track_form, track_index, track_type } =
  //  data[currentTrackIndex]
  const [track_form, setTrack_form] = useState(
    data[currentTrackIndex].track_form
  )
  // const [info, setInfo] = useState(track_form.info)
  // const [chronic_risk, setchronic_risk] = useState(second)
  // const [indicator, setindicator] = useState(second)
  const [guidelines, setguidelines] = useState(track_form.guidelines)
  useEffect(() => {
    console.log('currentTrackIndex', currentTrackIndex)
    if (data[currentTrackIndex]) {
      const { track_form } = data[currentTrackIndex]
      setTrack_form(track_form)
      setguidelines(track_form.guidelines)
    }
  }, [currentTrackIndex])
  useEffect(() => {
    console.log('當前 track_form', track_form)
    console.log('當前 guidelines', guidelines)
  }, [track_form, guidelines])

  console.log('trackform', track_form)
  const { info, chronic_risk, indicator } = track_form

  const age = dayjs().diff(birthday, 'year')
  // const { baseUrl, sendDiscordNotification, currentUser } =
  //   useContext(AuthContext)
  // const createPatient = '/api/crm/project/patient/createPatient'
  // const [isCardLoading, setIsCardLoading] = useState(false)

  const exerciseHabitTypeArr = ['1.無', '2.偶爾', '3.經常(每週累計達 150 分鐘)']
  const smokeHabitTypeArr = [
    '1.無',
    '2.偶爾',
    '3.平均一天約吸 10 支菸以下',
    '4.平均一天約吸 10 支菸（含）以上',
  ]
  const betelNutHabitTypeArr = ['1.無', '2.偶爾', '3.經常']
  const chronicRiskTypeArr = ['高風險', '中風險', '低風險', '不適用']

  return (
    <>
      <div className="metabolicPlanFormConfirm overflow-x-hidden mx-4 mx-lg-5 ">
        <Row className="text-center">
          <Col>
            病人姓名：<span className="h5">{name}</span>
          </Col>
          <Col>
            性別：
            <span className="h5">{gender === Number('1') ? '男' : '女'}</span>
          </Col>
          <Col sm={6}>
            出生日期：
            <span className="h5">
              {birthday}({age}歲)
            </span>
          </Col>
        </Row>
        <Row xs={2} className="mt-2">
          <Col className="border border-light-subtle border-1 border-end-0 p-3">
            <h5 className="mb-3">基本資料與生活習慣</h5>
            <p>身高：{info.height} 公分</p>
            <p>體重：{info.weight} 公斤</p>
            <p>運動：{exerciseHabitTypeArr[info.exercise_habit_type - 1]}</p>
            <p>抽菸：{smokeHabitTypeArr[info.smoke_habit_type - 1]}</p>
            <p>嚼檳榔：{betelNutHabitTypeArr[info.betel_nut_habit_type - 1]}</p>
          </Col>
          <Col className="border border-light-subtle border-1 p-3">
            <h5 className="mb-3">
              得到慢性病的風險 <span className="h6">（僅需收案時評估）</span>
            </h5>
            <p>冠心病：{chronicRiskTypeArr[chronic_risk.cad_risk_type - 1]}</p>
            <p>
              糖尿病：{chronicRiskTypeArr[chronic_risk.diabetes_risk_type - 1]}
            </p>
            <p>
              高血壓：
              {chronicRiskTypeArr[chronic_risk.hypertension_risk_type - 1]}
            </p>
            <p>
              腦中風：{chronicRiskTypeArr[chronic_risk.stroke_risk_type - 1]}
            </p>
            <p>
              心血管不良事件：
              {chronicRiskTypeArr[chronic_risk.cvd_risk_type - 1]}
            </p>
          </Col>
        </Row>
        <div className="metabolicIndicators border border-light-subtle border-1 border-end border-start px-3 pb-3">
          <h5 className="my-3">代謝症候群五大指標及身體質量指數（參考值）</h5>
          <p>
            腰圍：{indicator.waistline} 公分
            <span className="text-black-50">
              （男性 ≧ 90 公分，女性 ≧ 80 公分）
            </span>
          </p>
          <p>
            飯前血糖值：{indicator.blood_sugar_before_meal} mg/dL
            <span className="text-black-50">（≧ 100 mg/dL）</span>
          </p>
          <p>
            血壓：收縮壓 {indicator.sbp} mmHg、舒張壓 {indicator.dbp} mmHg
            <span className="text-black-50">
              （收縮壓 ≧ 130 mmHg，舒張壓 ≧ 85 mmHg）
            </span>
          </p>
          <p>
            三酸甘油脂值：{indicator.tg} mg/dL
            <span className="text-black-50">（≧ 150 mg/dL）</span>
          </p>
          <p>
            高密度脂蛋白膽固醇值：{indicator.hdl} mg/dL
            <span className="text-black-50">
              （男性 ＜ 40 mg/dL，女性 ＜ 50 mg/dL）
            </span>
          </p>
          <p>
            身體質量指數 BMI：{indicator.bmi} kg/m<sup>2</sup>
            <span className="text-black-50">（≧　27）</span>
          </p>
        </div>
        <div className="diseaseManagementGuidelines border border-secondary border-3 px-3 pb-3 mb-5">
          <h5 className="m-2 mt-4">
            疾病管理指引
            <span className="h6">
              （醫師對病人說明治療用藥外，亦須改善危險因子的重要性）
            </span>
          </h5>
          <div className="form-section">
            <div
              role="group"
              aria-labelledby="quitSmoking-radio-group"
              className="mt-2"
            >
              <label>
                <input
                  type="checkbox"
                  name="track_form.guidelines.quit_smoking.check"
                  value="1"
                  checked={guidelines.quit_smoking.check === 1}
                  onChange={() => {}}
                  readOnly
                />
                戒菸（吸菸 ≧ 10 支/日或尼古丁成癮度 ≧ 4
                分，可提供或轉介戒菸服務）
              </label>
              <div className="ms-3">
                <label>
                  <input
                    type="radio"
                    name="track_form.guidelines.quit_smoking.quit_smoking_type"
                    value="0"
                    checked={guidelines.quit_smoking.quit_smoking_type[0] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  戒菸指導（無意願接受戒菸服務或 ＜ 10 支/日或尼古丁成癮度 ＜ 4
                  分）
                </label>
                <label>
                  <input
                    type="radio"
                    name="track_form.guidelines.quit_smoking.quit_smoking_type"
                    value="1"
                    checked={guidelines.quit_smoking.quit_smoking_type[1] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  戒菸服務（≧ 10 支/日或尼古丁成癮度 ≧ 4 分）：
                </label>
                <div className="ms-3">
                  <label>
                    <input
                      type="radio"
                      name="track_form.guidelines.quit_smoking.service_type"
                      value="0"
                      checked={guidelines.quit_smoking.service_type[0] === 1}
                      onChange={() => {}}
                      readOnly
                    />
                    提供戒菸服務
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="track_form.guidelines.quit_smoking.service_type"
                      value="1"
                      checked={guidelines.quit_smoking.service_type[1] === 1}
                      onChange={() => {}}
                      readOnly
                    />
                    同意轉介戒菸服務
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-section">
            <div
              role="group"
              aria-labelledby="track_form.guidelines.quit_betel_nut.check"
              className="mt-2"
            >
              <label>
                <input
                  type="checkbox"
                  name="track_form.guidelines.quit_betel_nut.check"
                  value="1"
                  checked={guidelines.quit_betel_nut.check === 1}
                  onChange={() => {}}
                  readOnly
                />
                戒檳（6 個月內有嚼檳榔）
              </label>
              <div className="ms-3">
                <div>
                  <label>
                    <input
                      type="checkbox"
                      name="track_form.guidelines.quit_betel_nut.quit_betel_nut_type"
                      value="0"
                      checked={
                        guidelines.quit_betel_nut.quit_betel_nut_type[0] === 1
                      }
                      onChange={() => {}}
                      readOnly
                    />
                    戒檳目標：
                  </label>
                  {guidelines.quit_betel_nut.target_date
                    ? dayjs(guidelines.quit_betel_nut.target_date).format(
                        'YYYY-MM-DD'
                      )
                    : ''}

                  <span> 前戒除檳榔</span>
                </div>
                <div>
                  <label>
                    <input
                      type="checkbox"
                      name="track_form.guidelines.quit_betel_nut.quit_betel_nut_type"
                      value="1"
                      checked={
                        guidelines.quit_betel_nut.quit_betel_nut_type[1] === 1
                      }
                      onChange={() => {}}
                      readOnly
                    />
                    安排口腔黏膜檢查：
                  </label>
                  {guidelines.quit_betel_nut.oral_mucosa_check_date
                    ? dayjs(
                        guidelines.quit_betel_nut.oral_mucosa_check_date
                      ).format('YYYY-MM')
                    : ''}
                </div>
              </div>
            </div>
          </div>
          <div className="form-section">
            <div
              role="group"
              aria-labelledby="track_form.guidelines.food"
              className="mt-2"
            >
              <label>
                <input
                  type="checkbox"
                  name="track_form.guidelines.food.check"
                  value="1"
                  checked={guidelines.food.check === 1}
                  onChange={() => {}}
                  readOnly
                />
                每日建議攝取熱量（大卡/天）：
              </label>
              <div className="ms-3">
                <label>
                  <input
                    type="radio"
                    name="track_form.guidelines.food.caloric_intake_type"
                    value="1"
                    checked={
                      guidelines.food.caloric_intake_type === Number('1')
                    }
                    onChange={() => {}}
                    readOnly
                  />
                  1200
                </label>
                <label>
                  <input
                    type="radio"
                    name="track_form.guidelines.food.caloric_intake_type"
                    value="2"
                    checked={
                      guidelines.food.caloric_intake_type === Number('2')
                    }
                    onChange={() => {}}
                    readOnly
                  />
                  1500
                </label>
                <label>
                  <input
                    type="radio"
                    name="track_form.guidelines.food.caloric_intake_type"
                    value="3"
                    checked={
                      guidelines.food.caloric_intake_type === Number('3')
                    }
                    onChange={() => {}}
                    readOnly
                  />
                  1800
                </label>
                <label>
                  <input
                    type="radio"
                    name="track_form.guidelines.food.caloric_intake_type"
                    value="4"
                    checked={
                      guidelines.food.caloric_intake_type === Number('4')
                    }
                    onChange={() => {}}
                    readOnly
                  />
                  2000
                </label>
                <label>
                  <input
                    type="radio"
                    name="track_form.guidelines.food.caloric_intake_type"
                    value="5"
                    checked={
                      guidelines.food.caloric_intake_type === Number('5')
                    }
                    onChange={() => {}}
                    readOnly
                  />
                  其他：
                  {guidelines.food.caloric ? guidelines.food.caloric : ''}
                </label>
              </div>
            </div>
          </div>
          <div className="form-section">
            <div
              role="group"
              aria-labelledby="track_form.guidelines.food.reduce_food_type"
              className="mt-2"
            >
              <div className="ms-3">
                盡量減少
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.food.reduce_food_type"
                    value="friedFood"
                    checked={guidelines.food.reduce_food_type[0] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  油炸物
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.food.reduce_food_type"
                    value="sweets"
                    checked={guidelines.food.reduce_food_type[1] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  甜食
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.food.reduce_food_type"
                    value="salt"
                    checked={guidelines.food.reduce_food_type[2] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  鹽
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.food.reduce_food_type"
                    value="sugaryDrinks"
                    checked={guidelines.food.reduce_food_type[3] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  含糖飲料
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.food.reduce_food_type"
                    value="others"
                    checked={guidelines.food.reduce_food_type[4] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  其他：
                  {guidelines.food.other_food_type
                    ? guidelines.food.other_food_type
                    : ''}
                </label>
              </div>
            </div>
          </div>
          <div className="form-section">
            <div
              role="group"
              aria-labelledby="track_form.guidelines.exercise"
              className="mt-2"
            >
              <label>
                <input
                  type="checkbox"
                  name="track_form.guidelines.exercise.check"
                  value="1"
                  checked={guidelines.exercise.check === 1}
                  onChange={() => {}}
                  readOnly
                />
                運動建議：
              </label>
              <div className="ms-3">
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.exercise.exercise_type"
                    value="0"
                    checked={guidelines.exercise.exercise_type[0] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  提供運動指導:每週累積 150
                  分鐘中等費力運動（活動時仍可交談，但無法唱歌）
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.exercise.exercise_type"
                    value="1"
                    checked={guidelines.exercise.exercise_type[1] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  提供社區運動資源：
                  {guidelines.exercise.resource
                    ? guidelines.exercise.resource
                    : ''}
                </label>
              </div>
            </div>
          </div>
          <div className="form-section">
            <div
              role="group"
              aria-labelledby="track_form.guidelines.target_indicator"
              className="mt-2"
            >
              <label>
                <input
                  type="checkbox"
                  name="track_form.guidelines.target_indicator.check"
                  value="1"
                  checked={guidelines.target_indicator.check === 1}
                  onChange={() => {}}
                  readOnly
                />
                想達成的腰圍及體重：
              </label>
              <div className="ms-3">
                <label>
                  腰圍{' '}
                  {guidelines.target_indicator.target_waistline
                    ? guidelines.target_indicator.target_waistline
                    : ''}{' '}
                  公分、體重{' '}
                  {guidelines.target_indicator.target_waistline
                    ? guidelines.target_indicator.target_weight
                    : ''}{' '}
                  公斤
                </label>
              </div>
            </div>
          </div>
          <div className="form-section">
            <div className="mt-2">
              <label>
                <input
                  type="checkbox"
                  name="track_form.guidelines.blood_pressure_check"
                  value="1"
                  checked={guidelines.blood_pressure_check.check === 1}
                  onChange={() => {}}
                  readOnly
                />
                量血壓：指導 722 量測
              </label>
            </div>
          </div>
          <div className="mt-2">
            <label>
              <input
                type="checkbox"
                name="track_form.guidelines.other.check"
                value="1"
                checked={guidelines.other.check === 1}
                onChange={() => {}}
                readOnly
              />
              其他叮嚀：
            </label>
            <div className="ms-3">
              <div className="form-section">
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.other.other_type"
                    value="blood_sugar"
                    checked={guidelines.other.other_type[0] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  飯前血糖個人目標值：{' '}
                </label>
                {guidelines.other.blood_sugar_before_meal_target
                  ? guidelines.other.blood_sugar_before_meal_target +
                    ' mg/dL（%）'
                  : ''}
              </div>
              <div className="form-section">
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.other.other_type"
                    value="HbA1c"
                    checked={guidelines.other.other_type[1] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  醣化血紅素個人目標值：
                </label>
                {guidelines.other.HbA1c_before_meal_target
                  ? guidelines.other.HbA1c_before_meal_target + ' mg/dL（%）'
                  : ''}
              </div>
              <div className="form-section">
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.other.other_type"
                    value="tg"
                    checked={guidelines.other.other_type[2] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  三酸甘油脂個人目標值：
                </label>
                {guidelines.other.tg_target
                  ? guidelines.other.tg_target + ' mg/dL'
                  : ''}
              </div>
              <div className="form-section">
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.other.other_type"
                    value="hdl"
                    checked={guidelines.other.other_type[3] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  高密度脂蛋白膽固醇個人目標值：
                </label>
                {guidelines.other.hdl_target
                  ? guidelines.other.hdl_target + ' mg/dL'
                  : ''}
              </div>
              <div className="form-section">
                <label>
                  <input
                    type="checkbox"
                    name="track_form.guidelines.other.other_type"
                    value="ldl"
                    checked={guidelines.other.other_type[4] === 1}
                    onChange={() => {}}
                    readOnly
                  />
                  低密度脂蛋白膽固醇個人目標值：
                </label>
                {guidelines.other.ldl_target
                  ? guidelines.other.ldl_target + ' mg/dL'
                  : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MetabolicPlanFormConfirm
